import { useParams } from 'react-router-dom';
import { iframeOnLoadHelper } from '../../../helper/iframeOnLoadHelper';
import { ELDA_URL } from '../../../variables';
import Terms from '../../components/common/Terms';

const ApiDataPage = () => {

    const params = useParams();

    let src = '';

    let data = params ? params["*"] : undefined;

    if(!data || data === "undefined"){
        src = `${ELDA_URL}/data`
    } else {
        src = `${ELDA_URL}/data/${data}`
    }

    if(src.endsWith("/")){
        src = src.slice(0, -1);
    }

    return (
        <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
            <iframe
                title="ApiDataPage"
                src={src}
                style={{ width: '100%', height: 'calc(100vh - 95px)' }}
                onLoad={iframeOnLoadHelper}
            />
            <Terms />
        </div>
    );
};

export default ApiDataPage;
